import ApiService from '../apiservice'

export default class PlateService extends ApiService {
    constructor() {
        super('');
    }

    getTracks(idPlate) {
        return this.get('/tracks', { "id": idPlate });
    }

    getPlates() {
        return this.get('/plates');
    }

    getPlate(plate) {
        return this.get('/plate/description', { "plate": plate });
    }

    getPlateStatus(idPlate) {
        return this.get('/plate/status/api', { "id": idPlate });
    }

    addTrackers(data) {
        return this.post('/plate/tracker', data, 1);
    }

    removeLink(plateId) {
        return this.post('/plate/tracker/stop', { "plateId": plateId }, 1);
    }

    getLinkLoadRoute() {
        return this.get('/plates/loadroute/status');
    }


    getStatusRoutePlate(plate) {
        return this.get('/plate/loadroute/status', { "plate": plate });
    }
}